import React, {Component} from 'react';
import FocusPageId from "../../FocusPageId";
import {Link} from "react-router-dom";

let i = 0;

class MemberRegistration extends Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop = "50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });
    }

    constructor(props) {
        super(props);
        this.positionAdject = this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if (i < 300) {
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop = "0px";
        // }
    };

    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <h3><b>
                        <li>キャンセルについて</li>
                    </b></h3>
                     <div className="brElement"></div>

                    <h4 id="a"><b> 注文内容を変更したいです。（サイズ・枚数など）</b>
                    </h4>
                    <p className='all-content-font-size'> 原則、支払い完了後のキャンセルはお受けすることができません。
                    </p>
                    <p className='all-content-font-size'> 支払い完了前でのキャンセルはアカウントページから可能です。
                    </p>
                    <div className='col-md-10'></div>
                    <div className='col-md-2  col-12-custom'>
                        <Link to="/cancellationTopic">
                            <span className='font-size-20'>
                           戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>

        );
    }
}

export default MemberRegistration;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/Cancellation.js